import { render, staticRenderFns } from "./AcceptTermsModal.vue?vue&type=template&id=2712e27b&scoped=true"
import script from "./AcceptTermsModal.vue?vue&type=script&lang=ts"
export * from "./AcceptTermsModal.vue?vue&type=script&lang=ts"
import style0 from "./AcceptTermsModal.vue?vue&type=style&index=0&id=2712e27b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2712e27b",
  null
  
)

export default component.exports